<template>
  <div class="mt-1">
    <div class="d-flex justify-end align-center mb-5">
      <p class="mr-1 mb-0 caption blue-grey--text text--darken-2">
        {{ $t('common.more_info') }}
      </p>
      <v-menu open-on-hover offset-x max-width="300" right>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ml-1 blue-grey--text text--darken-1">
            mdi-information-outline
          </v-icon>
        </template>
        <div class="grey darken-4 px-3 py-5 text-center">
          <p
            v-html="
              $sanitize(
                $t('rev.validation.validated_impact_report_more_info'),
                { allowedTags: ['a'] }
              )
            "
            class="text-body-2 white--text"
          />
        </div>
      </v-menu>
    </div>
    <div class="graphic-container pt-2 side-borders">
      <div class="graphic d-flex align-center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div
              v-on="on"
              @mouseover="hoverFullInRange = true"
              @mouseleave="hoverFullInRange = false"
              class="bar-in-range"
              :class="{
                'bar-in-range__disabled':
                  hoverPartiallInRange || hoverInOutOfRange,
              }"
            />
          </template>
          <span v-html="$sanitize(data.inRange, { allowedTags: ['br'] })" />
        </v-tooltip>
      </div>
    </div>
    <div class="d-flex align-start">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
            @mouseover="hoverInOutOfRange = true"
            @mouseleave="hoverInOutOfRange = false"
            class="out-of-grid"
            :class="{ 'out-of-grid__darker': hoverInOutOfRange }"
          />
        </template>
        <p class="tooltip-container">
          {{ $t('rev.validation.validated_impact_out_of_range_info') }}
        </p>
      </v-tooltip>

      <div class="flex-grow-1 side-borders pb-2">
        <div class="graphic d-flex align-center border-bottom">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div
                v-on="on"
                @mouseover="hoverPartiallInRange = true"
                @mouseleave="hoverPartiallInRange = false"
                class="bar-out-of-range"
                :class="{
                  'bar-out-of-range__disabled':
                    hoverFullInRange || hoverInOutOfRange,
                }"
              />
            </template>
            <span
              v-html="$sanitize(data.outOfRange, { allowedTags: ['br'] })"
              width="100px"
            />
          </v-tooltip>
        </div>
      </div>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
            @mouseover="hoverInOutOfRange = true"
            @mouseleave="hoverInOutOfRange = false"
            class="out-of-grid"
            :class="{ 'out-of-grid__darker': hoverInOutOfRange }"
          />
        </template>
        <p class="tooltip-container">
          {{ $t('rev.validation.validated_impact_out_of_range_info') }}
        </p>
      </v-tooltip>
    </div>
    <div class="mt-4 px-12 d-flex">
      <span class="caption">{{
        formatDate(activeFilters.startDate, 'MMM DD, YYYY')
      }}</span>
      <span class="caption ml-auto">{{
        formatDate(activeFilters.endDate, 'MMM DD, YYYY')
      }}</span>
    </div>
    <div class="mt-3 d-flex justify-center">
      <div class="d-flex align-center mr-6">
        <div class="bar-indicator bar-indicator__in-range mr-2" />
        <p class="caption mb-0">
          {{ $t('insights.rev_impacts_fully_within_time_frame') }}
        </p>
      </div>
      <div class="d-flex align-center ml-6">
        <div class="bar-indicator bar-indicator__out-of-range mr-2" />
        <p class="caption mb-0">
          {{ $t('insights.rev_impacts_partially_within_time_frame') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { utils } from 'frontend-js-shared'

export default {
  name: 'ValidatedImpactsRepresentation',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      hoverFullInRange: false,
      hoverPartiallInRange: false,
      hoverInOutOfRange: false,
    }
  },

  computed: {
    ...mapState('report', {
      activeFilters: state => state.activeFilters,
    }),
  },

  methods: {
    formatDate(date, format) {
      return utils.dates.formatDate(date, format)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-container {
  width: 180px;
}
.graphic-container {
  margin-left: 80px;
  margin-right: 80px;
}

.side-borders {
  border-right: 1px solid $color-blue-grey-darken1;
  border-left: 1px solid $color-blue-grey-darken1;
}

.graphic {
  height: 40px;
  background: conic-gradient(
      from 90deg at 1px 1px,
      transparent 90deg,
      $color-blue-grey-lighten1 0
    )
    0 0/120px 40px;
}
.bar-in-range {
  width: 100%;
  height: 28px;
  background-color: #5cb2af;
  &__disabled {
    opacity: 0.25;
  }
}
.bar-out-of-range {
  width: 100%;
  height: 28px;
  background-color: #2a316c;
  &__disabled {
    opacity: 0.25;
  }
}
.out-of-grid {
  margin-top: 6px;
  width: 80px;
  height: 28px;
  background-color: $color-blue-grey-lighten2;
  &__darker {
    background-color: $color-blue-grey;
  }
}

.border-bottom {
  border-bottom: 1px solid $color-blue-grey-lighten1;
}

.bar-indicator {
  width: 42px;
  height: 14px;
  border-radius: 2px;
  &__in-range {
    background-color: #5cb2af;
  }
  &__out-of-range {
    background-color: #2a316c;
  }
}
</style>
